import React from 'react'
import { Col, Row } from 'react-bootstrap'

const CreateListNameAndDescription = props => {
  const { listData, handleListData } = props
  return (
    <>
      {' '}
      <Row>
        <Col md={6} xs={12}>
          <div className='shotbio'>
            <label>
              Name:<div className='mandatory'>*</div>
            </label>
            <input
              className='form-control'
              type='text'
              value={listData.title_en ? listData.title_en : ''}
              placeholder='please enter  Name in English'
              onChange={event => handleListData('title_en', event.target.value)}
            />
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className='shotbio'>
            <label>
              Name_Te:<div className='mandatory'>*</div>
            </label>
            <input
              className='form-control'
              type='text'
              value={listData.title_te ? listData.title_te : ''}
              placeholder='please enter  Name in Telugu'
              onChange={event => handleListData('title_te', event.target.value)}
            />
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={6} xs={12}>
          <div className='shotbio margintop'>
            <label>
              Description:<div className='mandatory'>*</div>
            </label>
            <textarea
              className='form-control'
              placeholder='enter Description'
              value={listData.description_en ? listData.description_en : ''}
              onChange={event => handleListData('description_en', event.target.value)}
              rows={5}
              cols={20}
            />
          </div>
        </Col>
        <Col md={6} xs={12}>
          <div className='shotbio margintop'>
            <label>
              Description_Te:<div className='mandatory'>*</div>
            </label>
            <textarea
              className='form-control'
              placeholder='enter Description '
              value={listData.description_te ? listData.description_te : ''}
              onChange={event => handleListData('description_te', event.target.value)}
              rows={5}
              cols={20}
            />
          </div>
        </Col>
      </Row>
    </>
  )
}

export default CreateListNameAndDescription
